import { createCtx } from '@shared/util/context';
import type { ToastAPI } from './MBToastTypes';

export const [useToast, ToastContextProvider, ToastContext] = createCtx<ToastAPI>();
